import React from 'react';
import { Progress } from 'reactstrap';
class ProgressBar extends React.Component{
    constructor(props){
        super();
        this.state = {
            progressPercentage: 0

        }

        this.onProgress = this.onProgress.bind(this);
    }

    onProgress(percent) {
        this.setState({progressPercentage:percent})
        console.log("this.state.progressPercentage"+this.state.progressPercentage);
    }

    render(){
        return(
        <div className="capture-photo-loader">
            <Progress bar animated color="success" value={this.state.progressPercentage}>{Math.round(this.state.progressPercentage)}%</Progress>
        </div>
    )}
};

export default ProgressBar;


// WEBPACK FOOTER //
// ./src/components/includes/ProgressBar.js